// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QFAA","colBig":"styles_colBig__3MlBI","colSmall":"styles_colSmall__1SQXM","shopifyNameWrapper":"styles_shopifyNameWrapper__1Xk-U"};